/**
 * Strip ALL html tags
 * @param string
 * @return {string}
 */
module.exports = string => {
    const regex = new RegExp(`<\/?[^>]+>`, 'gi');
    return string.toString().replace(regex, '');
};
